// Based on https://source.alphatrek.com/core-components/console-base/blob/master/src/managers/socket-manager.js
import ConnectMessage from './messages/connect';
import PongMessage from './messages/pong';
import eventHandler from '../eventBus';

export default class SocketManager {
	constructor() {
		var pong = new PongMessage();
		this.ping_timer = null;
		let max_missed_pings = -1;
		let missed_pings = 0;

		var ping_timer_event = () => {
			missed_pings += 1;
			if (missed_pings > max_missed_pings) {
				if (this.ping_timer) {
					clearInterval(this.ping_timer);
					this.ping_timer = null;
				}
				this.emit('timeout');
				this.close();
			}
		};
		this.on('message.ping', (message) => {
			this.send(pong);
			missed_pings = 0;
			if (!this.ping_timer) {
				var ping_interval_ms = message.sendInterval;
				max_missed_pings = message.maxMissedPings;
				this.ping_timer = setInterval(ping_timer_event, ping_interval_ms);
			}
		});
	}

	emit(name, payload) {
		eventHandler.$emit('controller.' + name, payload);
	}

	on(name, func) {
		eventHandler.$on('controller.' + name, func);
	}
	off(name, func) {
		eventHandler.$off('controller.' + name, func);
	}
	once(name, func) {
		eventHandler.$once('controller.' + name, func);
	}

	connect(token) {
		if (! this._url) {
			return;
		}

		this._ws = new WebSocket(this._url);

		this._ws.onopen = () => {
			this.send(new ConnectMessage({
				id: token,
				password: null,
				version: 2,
				clientType: 'CONSOLE',
				nonce: '',
			}));
		};
		this._ws.onerror = (evt) => {
			this.emit('error', evt);
		};
		this._ws.onclose = () => {
			this.emit('closed');
		};
		this._ws.onmessage = ({data: data}) => {
			var obj = null;
			try {
				obj = JSON.parse(data);
			} catch(err) {
				this.emit('error', `invalid message: ${data}`);
				return;
			}
			if (obj.type) {
				this.emit(`message.${obj.type}`, obj);
			} else {
				this.emit('message.unknown_type', obj);
			}
		};
	}

	send(message) {
		if (this._ws && this.is_open) {
			var messageStr = JSON.stringify(message);
			this.emit('sending', messageStr);
			this._ws.send(messageStr);
		} else {
			console.log('WS closed: failed to send', message);
			throw new Error('Unable to send on WebSocket: WebSocket is not open');
		}
	}

	close() {
		if (this.ping_timer) {
			clearInterval(this.ping_timer);
			this.ping_timer = null;
		}
		if (this._ws) {
			return this._ws.close();
		} else {
			return true;
		}
	}

	get is_open() {
		return this._ws && this._ws.readyState === WebSocket.OPEN;
	}

	set url(url) {
		if (this._url) {
			throw new Error('unable to reset websocket URL');
		}

		this._url = url;
	}

	get url() {
		return this._url;
	}
	get protocol_version() {
		return 2;
	}
	get raw_socket() {
		return this._ws;
	}
}
